var A4_LONG_MM = 297;
var A4_SHORT_MM = 210;

function ascii(text) {
  var out = new Uint8Array(text.length);
  var i;
  for (i = 0; i < text.length; i++) out[i] = text.charCodeAt(i) & 255;
  return out;
}

function concat(parts) {
  var total = 0;
  var i;
  for (i = 0; i < parts.length; i++) total += parts[i].length;
  var out = new Uint8Array(total);
  var offset = 0;
  for (i = 0; i < parts.length; i++) {
    out.set(parts[i], offset);
    offset += parts[i].length;
  }
  return out;
}

function sizeOf(parts) {
  var total = 0;
  var i;
  for (i = 0; i < parts.length; i++) total += parts[i].length;
  return total;
}

function pad10(n) {
  var s = String(n);
  while (s.length < 10) s = '0' + s;
  return s;
}

function pt(mm) {
  return Math.round(mm * 72 / 25.4 * 100) / 100;
}

function a4LandscapeRatio() {
  return A4_LONG_MM / A4_SHORT_MM;
}

function layoutA4(cssW, cssH) {
  var pageW = pt(A4_LONG_MM);
  var pageH = pt(A4_SHORT_MM);
  cssW = Math.max(1, Number(cssW) || 1);
  cssH = Math.max(1, Number(cssH) || 1);
  var scale = pageW / cssW;
  var scaledH = cssH * scale;
  var pageCount = 1;
  if (scaledH > pageH * 1.08) {
    pageCount = Math.ceil(scaledH / pageH - 1e-9);
  } else {
    scale = Math.min(pageW / cssW, pageH / cssH);
  }
  return {
    pageW: pageW,
    pageH: pageH,
    scale: scale,
    pageCount: pageCount
  };
}

function pageStream(layout, cssW, cssH, index) {
  var drawW = cssW * layout.scale;
  var drawH = cssH * layout.scale;
  var x = 0;
  var y = layout.pageH - drawH + index * layout.pageH;
  if (layout.pageCount === 1) {
    x = (layout.pageW - drawW) / 2;
    y = (layout.pageH - drawH) / 2;
  }
  return 'q\n0 0 ' + layout.pageW.toFixed(2) + ' ' + layout.pageH.toFixed(2) +
    ' re\nW\nn\n' +
    drawW.toFixed(2) + ' 0 0 ' + drawH.toFixed(2) + ' ' +
    x.toFixed(2) + ' ' + y.toFixed(2) + ' cm\n/Im0 Do\nQ\n';
}

function jpegToPdf(jpeg, cssW, cssH, imgW, imgH) {
  var layout = layoutA4(cssW, cssH);
  var pageCount = layout.pageCount;
  var slots = [];
  var nextId = 4;
  var i;
  for (i = 0; i < pageCount; i++) {
    slots.push({ content: nextId++, page: nextId++ });
  }
  var objectCount = nextId - 1;
  var kids = [];
  for (i = 0; i < pageCount; i++) kids.push(slots[i].page + ' 0 R');

  var parts = [];
  var offsets = [0];

  function push(chunk) {
    parts.push(typeof chunk === 'string' ? ascii(chunk) : chunk);
  }

  function obj(body) {
    offsets.push(sizeOf(parts));
    push(body);
  }

  push('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
  obj('1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
  obj('2 0 obj\n<< /Type /Pages /Count ' + pageCount + ' /Kids [' + kids.join(' ') + '] >>\nendobj\n');
  offsets.push(sizeOf(parts));
  push(
    '3 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + imgW + ' /Height ' + imgH +
    ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpeg.length +
    ' >>\nstream\n'
  );
  push(jpeg);
  push('\nendstream\nendobj\n');

  for (i = 0; i < pageCount; i++) {
    var stream = pageStream(layout, cssW, cssH, i);
    var box = layout.pageW.toFixed(2) + ' ' + layout.pageH.toFixed(2);
    obj(slots[i].content + ' 0 obj\n<< /Length ' + stream.length + ' >>\nstream\n' + stream + 'endstream\nendobj\n');
    obj(
      slots[i].page + ' 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + box +
      '] /Contents ' + slots[i].content + ' 0 R /Resources << /XObject << /Im0 3 0 R >> >> >>\nendobj\n'
    );
  }

  var xrefAt = sizeOf(parts);
  var xref = 'xref\n0 ' + (objectCount + 1) + '\n0000000000 65535 f \n';
  for (i = 1; i <= objectCount; i++) xref += pad10(offsets[i]) + ' 00000 n \n';
  xref += 'trailer\n<< /Size ' + (objectCount + 1) + ' /Root 1 0 R >>\nstartxref\n' + xrefAt + '\n%%EOF\n';
  push(xref);
  return concat(parts);
}

module.exports = {
  jpegToPdf: jpegToPdf,
  a4LandscapeRatio: a4LandscapeRatio
};
